import { render, staticRenderFns } from "./NoPageRoute.vue?vue&type=template&id=c00dc0c8&scoped=true&"
import script from "./NoPageRoute.vue?vue&type=script&lang=js&"
export * from "./NoPageRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00dc0c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c00dc0c8')) {
      api.createRecord('c00dc0c8', component.options)
    } else {
      api.reload('c00dc0c8', component.options)
    }
    module.hot.accept("./NoPageRoute.vue?vue&type=template&id=c00dc0c8&scoped=true&", function () {
      api.rerender('c00dc0c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/NoPageRoute.vue"
export default component.exports